<template>
  <div class="content-panel">
    <a-input-search
      v-model="subcompanyname"
      style="margin-bottom: 8px"
      placeholder="请输入设备参数"
      @search="queryDictData"
      @pressEnter="queryDictData"
      v-if="showSearch"
    />
    <a-button type="primary" @click="append()" block style="margin-bottom: 8px;" v-if="$auth('deviceParameter.add')">新建参数</a-button>
    <a-spin :spinning="loading" wrapperClassName="deviceParameterSpin">
      <a-card :bordered="false">
        <!--默认展开的-->
        <!--        :defaultExpandedKeys="defaultSelectedKeys"-->
        <a-tree
          style="height:100%"
          v-if="treeData.length > 0"
          :defaultCheckedKeys="defaultSelectedKeys"
          :treeData="treeData"
          @select="searchAssetTypeList"
          :showIcon="false"
          :defaultSelectedKeys="defaultSelectedKeys"
          :selectedKeys="selectedKeys"
          :draggable="$auth('deviceParameter.drag')"
          @drop="onDrop"
        >
          <template slot="custom" slot-scope="item">
            <span class="treeCompanyName">{{ item.name }}</span>
            <div class="icon-panel">
              <a-tooltip style="margin-left: 10px" v-if="$auth('deviceParameter.add')">
                <template slot="title">
                  新增
                </template>
                <a-icon @click.stop="append(item)" type="plus" />
              </a-tooltip>
              <a-tooltip v-if="$auth('deviceParameter.update')">
                <template slot="title">
                  编辑
                </template>
                <a-icon type="edit" v-action:update @click="() => edit(item)"/>
              </a-tooltip>
              <a-popconfirm placement="topRight" title="确定删除该参数吗?" @confirm="e => remove(item)">
                <a-tooltip v-if="$auth('deviceParameter.delete')">
                  <template slot="title">
                    删除
                  </template>
                  <a-icon v-if="item.isSystem !== 1" v-action:delete type="delete" style="color: red"/>
                </a-tooltip>
              </a-popconfirm>
            </div>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      :maskClosable="false"
      :width="500"
      @ok="handleSubmit"
      @cancel="visible = false"
      :confirmLoading="iconLoading"
      okText="保存">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="父节点" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" hasFeedback>
          <a-input
            autocomplete="off"
            :disabled="true"
            v-decorator="['pName', { rules: [{ required: true, message: '请输入父节点！'},{pattern: /^[^\s]*$/, message: '父节点不能包含空格！' },{max:50,message:'最多输入50个字'}] }]" />
        </a-form-item>
        <a-form-item label="名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" hasFeedback>
          <a-input
            autocomplete="off"
            v-decorator="['name', { rules: [{ required: true, message: '请输入名称！'},{pattern: /^[^\s]*$/, message: '名称不能包含空格！' },{max:50,message:'最多输入50个字'}] }]" />
        </a-form-item>
        <a-form-item label="编码" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" hasFeedback>
          <a-input
            :disabled="modalType === 'edit'"
            autocomplete="off"
            v-decorator="['code', { rules: [{ required: true, message: '请输入编码!' },{pattern: /^[^\s]*$/, message: '编码不能包含空格！' },{max:50,message:'最多输入50个字'}] }]" />
        </a-form-item>
        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
          <a-textarea
            v-decorator="['remark',{ rules: [{ required: false, message: '请输入备注！' }, {pattern: /^[^\s]*$/, message: '备注不能包含空格！' }, {max:225,message:'最多输入225个字'}] }]"
            :rows="4" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getDeptTreeList } from '@/api/assetLedger'
import { deleteParam, getDeviceType, getTreeDeviceType } from '@/api/deviceParameter'
import { createDictInfo, deleteDictInfo, dragDictInfo, editDictInfo, getDictInfo } from '@/api/dict'
import { dragDeviceType } from '@/api/deviceType'
export default {
  name: 'OrgTree',
  components: {
  },
  props: ['isOut', 'showSearch'],
  data () {
    return {
      loading: false,
      subcompanyname: '',
      treeData: [],
      defaultSelectedKeys: [],
      selectedKeys: [0],
      selectedData: {},
      // 用于测试
      code: 'null0',
      visible: false,
      form: this.$form.createForm(this, { name: 'coordinated' }),
      iconLoading: false,
      pid: '',
      modalTitle: '新增参数',
      modalType: '',
      modalData: {},
      childrenPid: '',
      uniqueValue: 0
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'dept_form' })
  },
  created () {
    // 获取使用部门
    this.getDeptData()
    this.getDictList()
  },
  methods: {
    ...mapActions(['handleTypeCode']),
    async getDeptData (type) {
      const data = {
        pCode: 'EQUIPMENT_PARAM',
        dimName: this.subcompanyname
      }
      this.loading = true
      getTreeDeviceType(data).then(res => {
        if (res.status === 0) {
          res.data.map(item => {
            item.scopedSlots = { title: 'custom' }
          })
          if (type !== 'search') {
            this.defaultSelectedKeys = [res.data[0].key]
            this.selectedKeys = [res.data[0].key]
            this.uniqueValue++
            this.handleTypeCode({
              code: res.data[0].code,
              uniqueValue: this.uniqueValue
            })
          }
          this.treeData = res.data
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
    },
    // 调用父组件的获取资产类型数据方法
    searchAssetTypeList (keys, info) {
      if (info.selectedNodes.length > 0) {
        this.selectedKeys = keys
        this.selectedData = info.selectedNodes[0].data.props
      }
      this.uniqueValue++
      this.handleTypeCode({
        code: this.selectedData.code,
        uniqueValue: this.uniqueValue
      })
    },
    // 搜索设备分类
    queryDictData () {
      this.getDeptData('search')
    },
    // 获取字典列表
    getDictList () {
      const query = {
        paging: false,
        name: ''
      }
      getDictInfo(query).then(res => {
        const index = res.data.findIndex(item => item.code === 'EQUIPMENT_PARAM')
        this.pid = res.data[index].id
      })
    },
    // 打开新增弹窗
    append (data) {
      this.iconLoading = false
      this.modalTitle = '新增参数'
      this.modalType = data ? 'addChildren' : 'add'
      this.modalData = {}
      this.visible = true
      if (data) {
        this.childrenPid = data.id
      }
      this.$nextTick(() => {
        this.form.setFieldsValue({
          pName: data ? data.name : '一级参数',
          name: '',
          code: '',
          remark: ''
        })
      })
    },
    // 提交
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.iconLoading = true
          if (this.modalType === 'add' || this.modalType === 'addChildren') {
            const arg = {
              pid: this.modalType === 'add' ? this.pid : this.childrenPid,
              name: values.name,
              code: values.code,
              remark: values.remark
            }
            createDictInfo(arg).then(res => {
              if (res.status === 0) {
                this.$message.success('新增成功')
                this.visible = false
                this.getDeptData('search')
                this.iconLoading = false
              } else {
                this.$message.error(res.info.message)
                this.iconLoading = false
              }
            })
          } else {
            const arg = {
              pid: this.modalData.pid,
              id: this.modalData.id,
              name: values.name,
              code: values.code,
              remark: values.remark
            }
            editDictInfo(arg).then(res => {
              if (res.status === 0) {
                this.$message.success('编辑成功')
                this.visible = false
                this.getDeptData('search')
                this.iconLoading = false
              } else {
                this.$message.error(res.info.message)
                this.iconLoading = false
              }
            })
          }
        }
      })
    },
    // 编辑
    edit (data) {
      this.iconLoading = false
      this.modalTitle = '编辑参数'
      this.modalType = 'edit'
      this.modalData = data
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue({
          pName: data.pName,
          name: data.name,
          code: data.code,
          remark: data.remark
        })
      })
    },
    // 删除字典
    async remove (data) {
      // 先请求后端接口，删除成功后执行
      let res
      // 如果存在ID那么需要调接口删除
      if (data.key) {
        const params = {
          typeCode: data.code,
          id: data.id
        }
        res = await deleteParam(params)
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.getDeptData()
        } else {
          this.$message.error(res.info.message)
        }
      }
    },
    // 拖拽
    onDrop (info) {
      const vm = this
      var realPos, query
      console.log('拖拽的INFO', info)

      const dropKey = info.node.eventKey
      const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dragPos = info.dragNode.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      // const parentNode = info.dragNode.pos.split('-')[1]

      // console.log('dropPos', dropPos)
      // console.log('dragPos', info.dragNode.pos.split('-'))
      // console.log('parentNode', info.dragNode.pos.split('-')[1])

      if (dragPos.length === dropPos.length && dragPos[dragPos.length - 2] === dropPos[dropPos.length - 2]) {
        if (dropPosition === -1) {
          realPos = Number(dropPos[dropPos.length - 1]) + 1
        } else {
          realPos = Number(dropPos[dropPos.length - 1]) + 2
        }
        if (Number(dragPos[dragPos.length - 1]) < Number(dropPos[dropPos.length - 1])) {
          realPos = realPos - 1
        }
      } else {
        if (dropPosition === -1) {
          realPos = info.dropPosition + 2
        } else {
          realPos = info.dropPosition + 1
        }
      }

      query = {
        id: dragKey,
        pid: dropPosition === 0 ? dropKey : info.node.dataRef.pid,
        position: realPos
      }

      // console.log('query', query)
      // console.log('dropPosition', dropPosition)

      let showTitle = ''
      if (dropPosition === 0) {
        console.log('长度', info.node.dataRef.children.length)
        const childPos = info.node.dataRef.children.length + 1
        query.position = childPos

        showTitle = `您确定修改【${info.dragNode.dataRef.name}】的父节点为【${info.node.dataRef.name}】并调整顺序为第【${childPos}】位吗?`
      } else {
        showTitle = `您确定修改【${info.dragNode.dataRef.name}】的父节点为【${info.node.dataRef.pName ||
        '一级菜单'}】并调整顺序为第【${query.position}】位吗?`
      }

      this.$confirm({
        title: showTitle,
        onOk () {
          return new Promise((resolve, reject) => {
            setTimeout(resolve, 1000)
            vm.Drop(info, query)
          }).catch(() => console.log('errors!'))
        },
        onCancel () {}
      })
    },
    // 字典拖拽
    async Drop (info, query) {
      const res = await dragDictInfo(query)
      console.log('拖拽的返回', res)

      if (res.status === 0) {
        this.$message.success('操作成功!')
        // 拖拽完后重新获取树信息(因为sort值已经改变)
        this.getDeptData('search')
      } else {
        this.$message.error(res.info.message)
      }
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;

        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-switcher_close{
          background: url('../../../../src/assets/icon-close.svg') no-repeat 5px 4px !important;
          svg{
            display: none !important;
          }
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.deviceParameterSpin {
  height: calc(100% - 40px);
  overflow: auto;
}
.treeCompanyName {
  font-size: 14px;
}
</style>
